import React from 'react';
import './Team.css'
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
//import { Swiper, SwiperSlide } from "swiper/react";
//import "swiper/css";
//import "swiper/css/pagination";
//import { Pagination, Autoplay } from "swiper";

const Team = () => {
    return(
        <>
        <section id="team" className="team section-bg">
      <div className="container" data-aos="fade-up">
        <div className="section-header">
          <h1 className='h3-tag'>Team</h1>
          <p className='p-tag'>Meet some of our hardworking team</p>
          <span class="line-bar">...</span><br />
        </div>

        <div className="row">

          <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="100">
            <div className="member">
              <img src={"assets/images/team/client-1.jpg"} class="img-fluid" alt=""/>
              <div className="member-info">
                <div className="member-info-content">
                  <h4>Kwodwo Nelson</h4>
                  <span>Head Master</span>
                  <div className="social-l">
                    <a href="#lu"><i class="fa-brands fa-twitter"><FaTwitter/></i></a>
                    <a href="#lu"><i class="fa-brands fa-facebook"><FaFacebook/></i></a>
                    <a href="#lu"><i class="fa-brands fa-instagram"><FaInstagram/></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="200">
            <div className="member">
              <img src={"assets/images/team/client-2.jpg"} className="img-fluid" alt=""/>
              <div className="member-info">
                <div className="member-info-content">
                  <h4>Mike Ankarah</h4>
                  <span>Assistant Headmaster</span>
                  <div className="social-l">
                    <a href="#lu"><i class="fa-brands fa-twitter"><FaTwitter/></i></a>
                    <a href="#lu"><i class="fa-brands fa-facebook"><FaFacebook/></i></a>
                    <a href="#lu"><i class="fa-brands fa-instagram"><FaInstagram/></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="300">
            <div className="member">
              <img src={"assets/images/team/client-3.jpg"} class="img-fluid" alt=""/>
              <div className="member-info">
                <div className="member-info-content">
                  <h4>Leticia Adu Cindy</h4>
                  <span>Head of All Teachers</span>
                  <div className="social-l">
                    <a href="#lu"><i class="fa-brands fa-twitter"><FaTwitter/></i></a>
                    <a href="#lu"><i class="fa-brands fa-facebook"><FaFacebook/></i></a>
                    <a href="#lu"><i class="fa-brands fa-instagram"><FaInstagram/></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="400">
            <div className="member">
              <img src={"assets/images/team/client-4.jpg"} class="img-fluid" alt=""/>
              <div className="member-info">
                <div className="member-info-content">
                  <h4>Amanda Henaopeh</h4>
                  <span>Accountant</span>
                  <div class="social-l">
                    <a href="#lu"><i class="fa-brands fa-twitter"><FaTwitter/></i></a>
                    <a href="#lu"><i class="fa-brands fa-facebook"><FaFacebook/></i></a>
                    <a href="#lu"><i class="fa-brands fa-instagram"><FaInstagram/></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </section>
        </>
    )
}

export default Team;